// JIRA: LOGISPRD-14782
import { useMemo, useRef } from 'react'
import { isCoMingleShipper, shipperScopeOf } from '@/components/system/shipperScope'
import { useFeatureFlagBoolean } from '@/services/feature/useFeatureQueries'
import { AuthStorage } from '@/utils/storage/AuthStorage'

export interface CoMingleShipperScope {
  /** false 인 동안 화면은 화주 범위를 만들지 않는다 */
  ready: boolean
  /** `withCoMingle` 두 번째 인자로 넘긴다 */
  coMingle: boolean
}

/**
 * 재고통합 FF(`feature.coMingle.inboundEnabled`)를 화주 범위([withCoMingle])에 넘길 값으로 고정한다 (LOGISPRD-14782).
 *
 * - FF 로 결과가 달라지는 계정은 잠긴 29CM·INOOINT 뿐이다([isCoMingleShipper]). 그 밖의 계정은 FF 를
 *   기다리지 않고 처음부터 `ready: true`·`coMingle: false` 다 (SG 결정 2026-10-19)
 * - 대상 계정은 FF 첫 조회가 끝날 때까지 `ready: false`. 조회 실패는 `coMingle: false`
 * - 편집 중 FF 재조회로 화주 옵션과 조회 화주가 바뀌지 않도록 진입 시점 값으로 고정한다
 *   (반품 화면 `withCoMingleReturns` 와 같은 방식)
 *
 * 반품 화면(`useCoMingleReturns`)과 같은 필드를 읽어 켜고 끌 때 함께 움직인다.
 */
export const useCoMingleShipperScope = (): CoMingleShipperScope => {
  const target = useMemo(() => isCoMingleShipper(shipperScopeOf(AuthStorage.user.get())), [])
  const flag = useFeatureFlagBoolean('feature.coMingle', 'inboundEnabled')
  const fixed = useRef<boolean>()
  if (!target) return { ready: true, coMingle: false }
  if (fixed.current === undefined && flag.isPending) return { ready: false, coMingle: false }
  fixed.current ??= !flag.isError && flag.data === true
  return { ready: true, coMingle: fixed.current }
}
